// Default matches previous release URL; override with REACT_APP_API_URL in .env
// export const API_URL =
//   "https://apirealestate.appgrowthcompany.com//api/v1/admin/"; //development

export const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:4019/api/v1/admin/";

export const END_POINTS = {
  //onboarding
  login: "login",
  getUser: "profile",
  forgetPassword: "forgotNewPassword",
  verifyOtp: "verifySendOTP",
  updateProfile: "updateProfile",
  resetPassword: "setPassword",
  changePassword: "changepassword",
  upload: "upload",

  //user
  updateUser: "updateUser",
  user: "getUsersList",
  getUsers: "getUser",
  exportUser: "exportUserList",
  deleteUser: "deleteUser",

  // dashboard
  dashboard: "dashboard",
  totalUserGraph: "totalUser",
  totalEarning: "totalEarning",
  propertiesSearchedByArea: "propertiesSearchedByArea",
  dashboardExport: "dashboardExport",

  //main
  property: "property",
  cms: "cms",
  area: "area",
  getAreaById: "getAreaById",
  category: "category",
  membership: "membership",
  subscriptions: "subscriptions",
  payment: "payments",
  notification: "notification",
  label: "label",
  subadmin: "subadmin",
  getMyNotifications: "getMyNotifications",
  readMyNotification: "readMyNotification",
  readAllMyNotifications: "readAllMyNotifications",
  clearMyNotification: "clearMyNotification",
  faqs: "faq",
  tutorial: "tutorial",
  getPropertyExportCsv: "getPropertyExportCsv",
  getPaymentsExportCsv: "getPaymentsExportCsv",
  getAgentRequests: "getAgentRequests",
  refundRequest: "refundRequest",
  refundStatus: "refundStatus",
  realEstateLink: "realEstateLink",

  // Staging-only Demo Tools (backend ENABLE_DEMO_TOOLS)
  demoToolsConfig: "demoTools/config",
  demoToolsProperty: "demoTools/property",
  demoToolsUser: "demoTools/user",
  demoToolsRefund: "demoTools/refund",

  //discount
  discount: "discount",
  usersDropDown: "usersDropDown",
};
